import React from 'react';
import { PackageCheck, Check, X, Clock } from 'lucide-react';
import type { MockInboundSummary } from '@/types/purchaseFlow';

const IQC_ICONS: Record<string, React.ReactNode> = {
  passed: <Check className="w-3 h-3 text-emerald-500" />,
  failed: <X className="w-3 h-3 text-red-500" />,
  pending: <Clock className="w-3 h-3 text-amber-500" />,
  waived: <Check className="w-3 h-3 text-gray-400" />,
};

interface InboundSummaryBlockProps {
  data: unknown;
}

const InboundSummaryBlock: React.FC<InboundSummaryBlockProps> = ({ data }) => {
  const ib = data as MockInboundSummary;
  if (!ib?.inbound_number) return null;

  return (
    <div className="mt-2 rounded-lg border border-emerald-200 dark:border-emerald-800 bg-emerald-50 dark:bg-emerald-900/20 p-3 text-xs">
      <div className="flex items-center gap-2 mb-2">
        <PackageCheck className="w-4 h-4 text-emerald-600" />
        <span className="font-semibold text-emerald-800 dark:text-emerald-300">Inbound {ib.inbound_number}</span>
        <span className="ml-auto text-gray-500">{ib.received_date}</span>
      </div>

      <div className="space-y-1">
        {ib.items.map(item => (
          <div key={item.line_no} className="flex items-center justify-between text-gray-600 dark:text-gray-400">
            <div className="flex items-center gap-2">
              {IQC_ICONS[item.iqc_status] || IQC_ICONS.pending}
              <span className="truncate">{item.product_name}</span>
            </div>
            <span className="font-mono whitespace-nowrap">
              {item.received_qty}/{item.po_qty}
            </span>
          </div>
        ))}
      </div>

      <div className="mt-2 pt-1.5 border-t border-emerald-200 dark:border-emerald-800 flex justify-between text-gray-600 dark:text-gray-400">
        <span>Total</span>
        <span className="font-mono font-medium">{ib.currency} {ib.total_amount.toLocaleString()}</span>
      </div>
    </div>
  );
};

export default InboundSummaryBlock;
